module.exports = __webpack_public_path__ + "05_medium_gray.79986c0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer5/05_medium_gray.png
// module id = oBYR
// module chunks = 0